module.exports = __webpack_public_path__ + "img/pending.34c36304.png";